import { QueryClient } from "@tanstack/react-query";
import { isApiError } from "./errors";

/**
 * Retries only for transient failures; 4xx (including 401/403/404/422) never retry, and neither does a
 * request dropped because this tab moved to another organisation (it would only be dropped again).
 */
export function shouldRetry(failureCount: number, error: unknown): boolean {
  if (isApiError(error) && error.code === "ORGANISATION_CHANGED") return false;
  if (isApiError(error) && error.status !== null && error.status < 500) return false;
  return failureCount < 2;
}

export function createQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: { staleTime: 30_000, retry: shouldRetry, refetchOnWindowFocus: true },
      mutations: { retry: false },
    },
  });
}
